module.exports = __webpack_public_path__ + "img/icon-undefined.eb0a10af.svg";